module.exports = __webpack_public_path__ + "img/89.e8c5c199.jpg";